import { __awaiter, __generator } from "tslib";
import { fetchGet } from '../../common/http/fetch-get';
import { getRetailersApiConfig } from './config/actions';
export var fetchGroupRetailers = function (groupId) { return __awaiter(void 0, void 0, void 0, function () {
    var config, url;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                config = getRetailersApiConfig();
                url = config.baseUrl + "/v1/group/" + groupId + "?marketLocale=" + config.marketLocale;
                return [4 /*yield*/, fetchGet(url)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
